// Module
var code = "<section class=\"bProgressBar\"> <div class=\"bProgressBar__bar\"> <div class=\"bProgressBar__barCover\" ng-style=\"{ 'width': bProgressBar.barPercentage + '%' }\" ng-class=\"{ max: bProgressBar.bar >= bProgressBar.max }\"></div> <div class=\"transclude\" ng-transclude></div> </div> </section>";
// Exports
module.exports = code;